import React from 'react'
import { } from 'react-router-dom';

import Navbar from './Navbar';
import style from './Arobics.module.css'

import Category from './Category';
const Arobics = () => {
    
  return (
    <>
    <Navbar/>
      
   <div className={style.hero_section}>
            <h2 className={style.hero_title}>Move Your Body, Energize Your Life</h2>
            <p className={style.hero_text}>
              Feel the rhythm, boost your energy, burn calories, and transform your fitness with fun, powerful aerobic workouts every day.
              
            </p>
          </div>
    
         <Category/>
                          
                     
    </>
  )
}

export default Arobics;